/**
 * How long something has waited, the Bureau's short way (mock-up: « 2 h », « 6 j », « hier »,
 * « t'attend depuis 2 h »). `now` is an argument: the functions are pure.
 */

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** « à l'instant », « 12 min », « 3 h », « hier », « 6 j », « 3 mois »; null for no date. */
export function compactAge(iso: string | null | undefined, now: Date = new Date()): string | null {
  if (!iso) return null;
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return null;
  const age = now.getTime() - t;
  if (age < MINUTE) return 'à l’instant';
  if (age < HOUR) return `${Math.floor(age / MINUTE)} min`;
  if (age < DAY) return `${Math.floor(age / HOUR)} h`;
  const days = Math.floor(age / DAY);
  if (days === 1) return 'hier';
  if (days < 60) return `${days} j`;
  return `${Math.floor(days / 30)} mois`;
}

/** « t'attend depuis 2 h », « t'attend depuis hier », « vient d'arriver »; null for no date. */
export function waitingSinceText(iso: string | null | undefined, now: Date = new Date()): string | null {
  const age = compactAge(iso, now);
  if (!age) return null;
  if (age === 'à l’instant') return 'vient d’arriver';
  return `t'attend depuis ${age}`;
}

/** « il y a 2 h », « hier », « à l'instant » — a past moment said as a phrase; null for no date. */
export function agoText(iso: string | null | undefined, now: Date = new Date()): string | null {
  const age = compactAge(iso, now);
  if (!age) return null;
  return age === 'à l’instant' || age === 'hier' ? age : `il y a ${age}`;
}
